module.exports = __webpack_public_path__ + "img/hamamatsu.77100720.jpg";